import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './StaticPage.css';

// Component
import StaticPageManagement from '../../../components/siteadmin/StaticPageManagement/StaticPageManagement';


class StaticPage extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getBlogParentPage: PropTypes.any,
        })
    };

    render() {

        return (
            <StaticPageManagement />
        );
    }
}

export default compose(
    withStyles(s),
)(StaticPage);